// extracted by mini-css-extract-plugin
export default {"header":"AdminDocumentList_header__8-LKn","cell":"AdminDocumentList_cell__2NAkN"};